<template>
  <div class="main-content">
    <avue-crud
      :data="tableData"
      :option="option"
      :table-loading="showLoading"
      :page.sync="page"
      @on-load="onLoad"
    >
      <template #header>
        <div>
          <div class="flex flex-wrap align-items marginBottom20">
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width70 textAlignRight"
                >公司名称 :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.companyName"
                  placeholder="请输入"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width70 textAlignRight"
                >用户姓名 :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.username"
                  placeholder="请输入"
                  clearable
                  maxlength="20"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width70 textAlignRight"
                >电话 :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.phone"
                  placeholder="请输入"
                  clearable
                  maxlength="20"
                ></el-input>
              </div>
            </div>
            <!-- <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width70 textAlignRight"
                >职位 :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.post"
                  placeholder="请输入"
                  clearable
                  maxlength="20"
                ></el-input>
              </div>
            </div> -->
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width70 textAlignRight"
                >申请状态 :
              </span>
              <div class="width300">
                <el-select
                  class="width300"
                  v-model="searchData.state"
                  clearable
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in OOrderStatus"
                    :key="item.id"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width70 textAlignRight"
                >申请时间 :
              </span>
              <div class="width300">
                <el-date-picker
                  v-model="searchData.createTime"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :clearable="true"
                >
                </el-date-picker>
              </div>
            </div>

            <div class="flex align-items marginRight10 marginBottom10">
              <el-button size="medium" type="primary" @click="handleSearch"
                >搜索</el-button
              >
            </div>

            <div class="flex align-items marginRight10 marginBottom10">
              <el-button size="medium" type="info" @click="handleReset"
                >重置</el-button
              >
            </div>
          </div>
        </div>
      </template>
      <!-- <template slot="title" slot-scope="{ option }">
        <div class="custom-title">
          <span>自定义标题</span>
          <span class="total">总数：{{ option.total }}</span>
        </div>
      </template> -->
      <template slot="state" slot-scope="{ row }">
        {{ row.state == 1 ? "待处理" : row.state == 2 ? "已处理" : "" }}
      </template>
      <template slot="menu" slot-scope="{ row }">
        <!-- <el-button
          type="text"
          size="mini"
          icon="el-icon-view"
          @click="handleDetails(row)"
          >详情</el-button
        > -->
        <!-- <el-button
          type="text"
          size="mini"
          @click="handleEdit(row)"
          v-if="row.state == 1"
          >通过</el-button
        > -->
        <el-button
          type="text"
          size="mini"
          @click="handleCreate(row)"
          v-if="row.state == 1"
          >通过</el-button
        >
      </template>
    </avue-crud>
    <el-dialog
      v-if="dialogVisible"
      :title="`${'会员'}`"
      :visible.sync="dialogVisible"
      :custom-class="dialogHidden ? 'hidden-dialog-content' : ''"
      width="40%"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <avue-form ref="form" v-model="form" :option="formOption">
        <template slot="avatarUrl">
          <FormImgUpload
            :url="form.avatarUrl"
            @upload="upload"
            :limit="1"
            :maxSize="20"
            :accept="'.png,.jpg,.jpeg,.svg,.tiff'"
            :multiple="true"
            :disabled="isDetails"
          />
          <div style="color: #c0c1c3">
            建议尺寸：78px*78px，图片格式：.png,.jpg,.jpeg,.svg,.tiff
          </div>
        </template>
        <template slot="username">
          <el-input
            v-model="form.username"
            maxlength="20"
            placeholder="请输入"
            onkeyup="this.value=this.value"
            @blur="salaryDianChange($event, 'username')"
            type="text"
            clearable
            :disabled="isDetails"
          />
          <!-- onkeyup="this.value=this.value.match(/\d+\.?\d{0,2}/)" -->
        </template>
        <template slot="phone">
          <el-input
            v-model="form.phone"
            maxlength="11"
            placeholder="请输入"
            onkeyup="this.value=this.value"
            @blur="salaryDianChange($event, 'phone')"
            type="text"
            clearable
            :disabled="isDetails"
          />
        </template>
        <template slot="factoryId">
          <el-select
            v-model="form.factoryId"
            clearable
            style="width: 400px"
            :disabled="isDetails"
            filterable
          >
            <el-option
              v-for="item in classifyList"
              :key="item.id"
              :value="item.id"
              :label="item.name"
            ></el-option>
          </el-select>
        </template>
        <template slot="post">
          <el-input
            v-model="form.post"
            maxlength="20"
            placeholder="请输入"
            onkeyup="this.value=this.value"
            @blur="salaryDianChange($event, 'post')"
            type="text"
            clearable
            :disabled="isDetails"
          />
        </template>
        <template slot="type">
          <el-select
            v-model="form.type"
            clearable
            style="width: 400px"
            :disabled="isDetails"
            placeholder="请选择"
          >
            <el-option :value="1" label="合作伙伴员工"></el-option>
            <el-option :value="2" label="良信员工"></el-option>
          </el-select>
        </template>
        <template slot="role">
          <el-select
            v-model="form.role"
            clearable
            style="width: 400px"
            :disabled="isDetails"
            placeholder="请选择"
          >
            <el-option
              v-for="item in OMemberRole"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
        </template>

        <template slot="state">
          <el-switch
            v-if="!isDetails"
            :disabled="isDetails"
            v-model="form.state"
            :inactive-value="2"
            :active-value="1"
          ></el-switch>
          <div v-else>
            {{ form.state == 1 ? "启用中" : form.state == 2 ? "停用中" : "" }}
          </div>
        </template>

        <template slot="menuForm">
          <el-button @click="handleClose">
            {{ isDetails ? "关闭" : "取消" }}</el-button
          >
          <el-button
            type="primary"
            v-if="!isDetails"
            @click="submit(form)"
            :loading="showLoadingForm"
            >确定</el-button
          >
        </template>
      </avue-form>
    </el-dialog>
    <!-- <el-dialog
      v-if="dialogVisible"
      title="修改状态"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <avue-form ref="form" v-model="form" :option="formOption">
        <template slot="state">
          <el-select
            class="width250"
            v-model="form.state"
            clearable
            placeholder="请选择"
            style="width: 300px !important"
          >
            <el-option
              v-for="item in OOrderStatus"
              :key="item.id"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </template>

        <template slot="menuForm">
          <el-button @click="handleClose">
            {{ isDetails ? "关闭" : "取消" }}</el-button
          >
          <el-button
            type="primary"
            @click="submit(form)"
            :loading="showLoadingForm"
            >确定</el-button
          >
        </template>
      </avue-form>
    </el-dialog> -->
  </div>
</template>

<script>
import { joinExamineList, joinExamineStateUpdate } from "@/api/join/examine";
import { mapGetters } from "vuex";
import FormImgUpload from "@/components/formComponents/formImgUpload";
import {
  EApplicationStatus,
  MOrderStatus,
  OOrderStatus,
  OMemberRole,
} from "@/enums/beCurrent/EBeCurrent";
import dayjs from "dayjs";
import { emailRegex, mobilePhoneRule, passwordRule } from "@/utils/formRules";
import { memberManageAdd, manageFactoryList } from "@/api/user/manage";

export default {
  name: "index",
  components: {
    FormImgUpload,
  },
  // computed: {
  // 	...mapGetters(['getButton'])
  // },
  data() {
    return {
      EApplicationStatus: EApplicationStatus,
      MOrderStatus: MOrderStatus,
      OOrderStatus: OOrderStatus,
      OMemberRole: OMemberRole,
      button: {},
      showAuthority: true,
      isDetails: false,
      typeList: [],
      entryList: [],
      searchData: {
        companyName: "",
        createTime: "",
      },
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      tableData: [], //列表数据
      showLoading: false,
      showLoadingForm: false, //防重提交
      option: {
        title: "",
        titleSize: "h3",
        card: false,
        border: true,
        header: false,
        stripe: false, // 显示斑马纹
        showHeader: true, // 显示表头
        index: true, // 显示索引
        indexLabel: "序号", // 索引文字
        size: "small",
        selection: false, // 显示多选框
        page: true, // 显示分页
        align: "center",
        menuAlign: "center",
        menuType: "text",
        editBtn: false,
        delBtn: false,
        column: [
          {
            label: "申请用户姓名",
            prop: "username",
          },
          {
            label: "电话",
            prop: "phone",
          },
          {
            label: "公司名称",
            prop: "companyName",
          },
          // {
          //   label: "职位",
          //   prop: "post",
          // },
          {
            label: "状态",
            prop: "state",
          },
          {
            label: "申请时间",
            prop: "createTime",
          },
        ],
      },

      dialogVisible: false,
      dialogHidden: false,
      form: {
        image: [],
        state: 1,
        avatarUrl: [
          "https://ahhfms.oss-cn-beijing.aliyuncs.com/7487b9949b3cb8bc6e3c740a3212ab5c48a6fbc476bc2c565b1f8cddcea7bb5e.png",
        ],
      },
      formOption: {
        submitBtn: false,
        submitText: "确定",
        emptyBtn: false,
        labelWidth: "120",
        row: true,
        column: [
          {
            label: "头像",
            prop: "avatarUrl",
            type: "text",
            maxlength: 50,
            span: 24,
            rules: [
              {
                required: true,
                message: "请上传",
                trigger: "blur",
              },
              {
                validator: (rule, value, callback) => {
                  if (value.length === 0) {
                    callback(new Error("请上传"));
                  } else {
                    callback();
                  }
                },
              },
            ],
          },
          {
            label: "会员名称",
            prop: "username",
            type: "text",
            maxlength: 20,
            placeholder: "请输入",
            span: 14,
            rules: [
              {
                required: true,
                message: "请输入",
                trigger: "blur",
              },
            ],
          },
          {
            label: "职位",
            prop: "post",
            type: "text",
            maxlength: 200,
            placeholder: "请输入",
            span: 14,
            rules: [
              {
                required: true,
                message: "请输入",
                trigger: "blur",
              },
            ],
          },
          {
            label: "申请类型",
            prop: "type",
            type: "select",
            span: 14,
            rules: [
              {
                required: true,
                message: "请选择",
                trigger: "change",
              },
            ],
          },
          {
            label: "所属公司",
            prop: "factoryId",
            type: "text",
            maxlength: 200,
            placeholder: "请输入",
            span: 14,
            rules: [
              {
                required: true,
                message: "请输入",
                trigger: "blur",
              },
            ],
          },
          {
            label: "角色",
            prop: "role",
            type: "select",
            placeholder: "请选择",
            span: 14,
            display: false,
            rules: [
              {
                required: true,
                message: "请选择角色",
                trigger: "change",
              },
            ],
          },
          {
            label: "手机号",
            prop: "phone",
            type: "text",
            maxlength: 11,
            placeholder: "请输入",
            span: 14,
            rules: [
              {
                required: true,
                message: "请输入",
                trigger: "blur",
              },
              ...mobilePhoneRule,
            ],
          },
          // {
          //   label: "密码",
          //   prop: "password",
          //   type: "password",
          //   maxlength: 20,
          //   placeholder: "请输入",
          //   value: "123456",
          //   span: 14,
          //   rules: [
          //     {
          //       required: true,
          //       message: "请输入",
          //       trigger: "blur",
          //     },
          //     ...passwordRule,
          //   ],
          // },
          {
            label: "状态",
            prop: "state",
            type: "text",
            maxlength: 100,
            span: 24,
            rules: [
              {
                required: true,
                message: "",
                trigger: "blur",
              },
            ],
          },
        ],
      },
      dialogPassWordVisible: false,
      dataUrl: "",
      classifyList: [],
    };
  },
  created() {},
  watch: {
    "form.type"(val) {
      const factoryIdCol = this.findObject(this.formOption.column, "factoryId");
      if (factoryIdCol) {
        if (val === 2) {
          this.$set(factoryIdCol, "display", false);
          this.form.factoryId = "";
        } else {
          this.$set(factoryIdCol, "display", true);
        }
      }
      const roleCol = this.findObject(this.formOption.column, "role");
      if (roleCol) {
        if (val === 1) {
          this.$set(roleCol, "display", true);
        } else {
          this.$set(roleCol, "display", false);
          this.form.role = "";
        }
      }
    },
  },
  methods: {
    //初始化
    onLoad() {
      const searchForm = {
        ...this.searchData,
      };
      if (this.searchData.createTime) {
        searchForm.createTimeStart = dayjs(
          this.searchData.createTime[0]
        ).format("YYYY-MM-DD 00:00:00");
        searchForm.createTimeEnd = dayjs(this.searchData.createTime[1]).format(
          "YYYY-MM-DD 23:59:59"
        );
      }
      delete searchForm.createTime;
      this.showLoading = true;
      joinExamineList({
        page: this.page.currentPage,
        size: this.page.pageSize,
        ...searchForm,
      }).then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.page.total = res.data.total;
        }
      });
      this.getClassifyList();
    },

    // 查询
    handleSearch() {
      // console.log('查询')
      this.page.currentPage = 1;
      this.onLoad();
    },
    // 重置
    handleReset() {
      // console.log('重置')
      // localStorage.removeItem("searchForm");
      this.searchData = {
        companyName: "",
        createTime: "",
      };
      this.page.currentPage = 1;
      this.onLoad();
    },

    // 通过
    handleCreate(row) {
      // const password = this.findObject(this.formOption.column, "password");
      // password.display = true;
      (this.form.avatarUrl = [
        "https://ahhfms.oss-cn-beijing.aliyuncs.com/7487b9949b3cb8bc6e3c740a3212ab5c48a6fbc476bc2c565b1f8cddcea7bb5e.png",
      ]),
        (this.form.username = row.username);
      this.form.phone = row.phone;
      // this.form.password = "123456";
      this.form.post = row.companyName;
      this.form.type = row.type !== undefined ? row.type : 1;
      this.form.factoryId = "";
      this.isDetails = false;
      this.form.id = "";
      this.form.joinId = row.id;
      this.dialogVisible = true;
    },
    //会员分类
    getClassifyList() {
      manageFactoryList({}).then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          this.classifyList = res.data;
        }
      });
    },
    //图片上传
    upload(e) {
      if (Array.isArray(e)) {
        this.form.avatarUrl = [...e];
      } else {
        this.form.avatarUrl = [...this.form.avatarUrl, e];
      }
    },

    // 重置form
    resetForm() {
      this.form = {
        id: "",
        type: "",
        avatarUrl: [
          "https://ahhfms.oss-cn-beijing.aliyuncs.com/7487b9949b3cb8bc6e3c740a3212ab5c48a6fbc476bc2c565b1f8cddcea7bb5e.png",
        ],
      };
    },

    // 关闭
    handleClose() {
      this.dialogVisible = false;
      this.dialogHidden = false;
      setTimeout(() => {
        this.resetForm();
      }, 500);
    },
    //输入
    salaryDianChange(e, t) {
      const value = e.target.value;
      this.form[t] = value;
    },
    // 提交
    submit(form) {
      this.$refs.form.$refs.form.validate((valid, done) => {
        if (valid) {
          if (this.showLoadingForm) {
            return;
          }
          this.showLoadingForm = true;
          // return
          const newData = {
            ...form,
            avatarUrl: form.avatarUrl[0],
          };
          memberManageAdd(newData)
            .then((res) => {
              if (res.code === 200) {
                this.$message.success("操作成功");
                this.dialogVisible = false;
                setTimeout(() => {
                  this.resetForm();
                }, 500);
                this.onLoad();
              } else if (res.code === 435) {
                this.handleFactoryIncomplete(res.msg);
              } else {
                this.$message.error(res.msg || "操作失败");
              }
              this.showLoadingForm = false;
            })
            .catch(() => (this.showLoadingForm = false));
        }
      });
    },
    /**
     * 处理接口返回435（盘厂资料未完善）提示并引导跳转盘厂列表
     * 通过无缝切换遮罩层并平滑隐藏当前弹窗，避免弹窗切换时的白屏闪烁
     * @param {string} msg 接口返回的错误提示信息
     * @returns {void}
     */
    handleFactoryIncomplete(msg) {
      this.dialogHidden = true;
      this.$confirm(
      
          "盘厂资料未完善，请前往【社区联盟-盘厂列表】点击【编辑】，填写盘厂档案信息",
        "提示",
        {
          confirmButtonText: "去完善",
          showCancelButton: false,
          showClose: false,
          closeOnPressEscape: false,
          type: "warning",
          closeOnClickModal: false,
          beforeClose: (action, instance, done) => {
            done();
            this.handleClose();
          },
        }
      )
        .then(() => {
          this.goToFactoryManage();
        })
        .catch(() => {});
    },
    /**
     * 跳转至盘厂管理页面并同步更新左侧菜单选中项与顶部标签栏
     * 采用路径归一化、包含关系与菜单名称多级容错匹配，结合异步二次高亮机制确保菜单项精准展开并激活
     * @returns {void}
     */
    goToFactoryManage() {
      const targetUrl = "/factory/manage";
      const menuList = this.$store.state.index.menu || [];
      let targetName = "盘厂列表";
      let subMenuIndex = "";

      // 路径归一化辅助函数，移除首尾斜杠与首尾空格
      const normalizeUrl = (url) => (url || "").trim().replace(/^\/+|\/+$/g, "");
      const normalizedTarget = normalizeUrl(targetUrl);

      // 第一优先级：路径归一化后完全匹配
      for (let i = 0; i < menuList.length; i++) {
        const item = menuList[i];
        if (item && item.children && item.children.length) {
          for (let j = 0; j < item.children.length; j++) {
            const child = item.children[j];
            if (child && normalizeUrl(child.url) === normalizedTarget) {
              targetName = child.name || targetName;
              subMenuIndex = `${i + 1}-${j + 1}`;
              break;
            }
          }
        }
        if (subMenuIndex) break;
      }

      // 第二优先级：路径包含关系匹配（如子路由包含 factory/manage）
      if (!subMenuIndex) {
        for (let i = 0; i < menuList.length; i++) {
          const item = menuList[i];
          if (item && item.children && item.children.length) {
            for (let j = 0; j < item.children.length; j++) {
              const child = item.children[j];
              if (
                child &&
                child.url &&
                (normalizeUrl(child.url).includes(normalizedTarget) ||
                  normalizedTarget.includes(normalizeUrl(child.url)))
              ) {
                targetName = child.name || targetName;
                subMenuIndex = `${i + 1}-${j + 1}`;
                break;
              }
            }
          }
          if (subMenuIndex) break;
        }
      }

      // 第三优先级：菜单名称精准或模糊匹配“盘厂列表”
      if (!subMenuIndex) {
        for (let i = 0; i < menuList.length; i++) {
          const item = menuList[i];
          if (item && item.children && item.children.length) {
            for (let j = 0; j < item.children.length; j++) {
              const child = item.children[j];
              if (
                child &&
                child.name &&
                (child.name === "盘厂列表" || child.name.includes("盘厂列表"))
              ) {
                targetName = child.name;
                subMenuIndex = `${i + 1}-${j + 1}`;
                break;
              }
            }
          }
          if (subMenuIndex) break;
        }
      }

      // 第四优先级：使用全局方法 $globalMethod 兜底查找
      if (!subMenuIndex && this.$globalMethod) {
        subMenuIndex =
          this.$globalMethod(targetUrl) ||
          this.$globalMethod("factory/manage") ||
          "";
      }

      // 1. 同步设置 Vuex 中菜单激活索引并派发事件
      if (subMenuIndex) {
        this.$store.commit("setSubMenuIndex", subMenuIndex);
        this.$root.eventHub.$emit("changeSubMenuIndex", subMenuIndex);
      }

      // 2. 触发顶部标签栏（Tab）新增或激活
      const tableTabs = this.$store.state.index.tableTabs || [];
      let exist = false;
      const tabData = {
        title: targetName,
        name: "0",
        url: targetUrl,
        index: subMenuIndex || "0",
      };

      tableTabs.forEach((item) => {
        if (
          (item.title && (item.title === tabData.title || item.title === "盘厂列表")) ||
          (item.url && normalizeUrl(item.url) === normalizedTarget)
        ) {
          tabData.name = item.name;
          exist = true;
        }
      });

      if (!exist) {
        let maxName = 0;
        tableTabs.forEach((item) => {
          const num = Number(item.name);
          if (!isNaN(num) && num > maxName) {
            maxName = num;
          }
        });
        tabData.name = (maxName + 1).toString();
      }

      this.$root.eventHub.$emit("changeTableTabs", { type: exist, data: tabData });

      // 3. 执行路由跳转
      this.$router.push({
        path: targetUrl,
      });

      // 4. 在微任务与延时宏任务中二次派发，确保路由切换完成后的稳定高亮与展开
      if (subMenuIndex) {
        this.$nextTick(() => {
          this.$store.commit("setSubMenuIndex", subMenuIndex);
          this.$root.eventHub.$emit("changeSubMenuIndex", subMenuIndex);
          this.$root.eventHub.$emit("changeTableTabs", { type: true, data: tabData });
        });
        setTimeout(() => {
          this.$store.commit("setSubMenuIndex", subMenuIndex);
          this.$root.eventHub.$emit("changeSubMenuIndex", subMenuIndex);
        }, 150);
      }
    },
    // // 提交
    // submit(form) {
    //   this.$refs.form.validate((valid, done) => {
    //     if (valid) {
    //       if (this.showLoadingForm) {
    //         return;
    //       }
    //       this.showLoadingForm = true;
    //       joinExamineStateUpdate({
    //         ...form,
    //       })
    //         .then((res) => {
    //           if (res.code === 200) {
    //             this.$message.success("操作成功");
    //             this.dialogVisible = false;
    //             setTimeout(() => {
    //               this.resetForm();
    //             }, 500);
    //             this.showLoadingForm = false;
    //             this.onLoad();
    //           }
    //         })
    //         .catch(() => (this.showLoadingForm = false));
    //     }
    //   });
    // },
    // 查询
    handleSearch() {
      // console.log('查询')
      this.page.currentPage = 1;
      this.onLoad();
    },
  },
};
</script>

<style scoped>
::v-deep .hidden-dialog-content {
  visibility: hidden !important;
  opacity: 0 !important;
}
.copy {
  cursor: pointer;
  /* width: 60px; */
  margin-left: 15px;
  color: #66b1ff;
}
.tips {
  font-size: 20px;
  line-height: 1;
  margin-bottom: 30px;
}
</style>
